export const iconSize = {
  /** (16px) */ sm: "1rem",
  /** (20px) */ md: "1.25rem",
  /** (24px) */ lg: "1.5rem",
  /** (32px) */ xl: "2rem",
} as const;
/**
 * height: ${iconSize.md};
 * width: ${iconSize.md};
 */
